import elementIsInView from '../utils/element-is-in-view.js';

const containers = {
  facets: document.querySelector('[data-searchanise-collection-facets]'),
  facetsPositionMarker: document.querySelector(
    '[data-collection-facets-position-marker]'
  ),
};

const positionFacetsBarOnScroll = () => {
  const scrolledPastMarker =
    containers.facetsPositionMarker.getBoundingClientRect().y < 0;
  const markerInView = elementIsInView(containers.facetsPositionMarker, false);
  const footerInView = elementIsInView(
    document.querySelector('#shopify-section-site-footer'),
    true
  );
  const facetsComputedStyle = getComputedStyle(containers.facets);
  const facetsBarHeight =
    parseInt(facetsComputedStyle.height, 10) -
    parseInt(facetsComputedStyle.paddingTop, 10) -
    parseInt(facetsComputedStyle.paddingBottom, 10);
  const filtersMenuIsHidden = document
    .querySelector('[data-filters-menu]')
    .classList.contains('hidden');

  // Don't do any of this is we've got thefilters menu open
  if (!filtersMenuIsHidden) {
    return;
  }

  containers.facets.classList.toggle(
    'facets-bar--show-at-bottom--hidden',
    footerInView
  );

  containers.facets.classList.toggle(
    'lg:mb-5',
    markerInView && !scrolledPastMarker
  );

  containers.facets.classList.toggle(
    'facets-bar--show-at-bottom',
    !markerInView && scrolledPastMarker
  );

  containers.facetsPositionMarker.style.height = markerInView
    ? 0
    : `${facetsBarHeight}px`;
};

export default positionFacetsBarOnScroll;
